import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { fetchImageByName } from "../../utils/utility";

const useStyles = makeStyles((theme) => ({
  background: {
    height: "90vh",
    [theme.breakpoints.down("sm")]: {
      height: "50vh",
    },
    position: "fixed",
    marginLeft: "60%",
    bottom: 0,
    zIndex: -1,
  },
}));

const DoctorComponent = ({ klass, smile }) => {
  const classes = useStyles();
  return (
    <img
      src={fetchImageByName(smile ? "doctor_smile" : "doctor")}
      alt="Doctor"
      className={klass ? klass : classes.background}
    />
  );
};

export default DoctorComponent;
